import React from 'react';
import Container from '@amzn/awsui-components-console/container';
import Header from '@amzn/awsui-components-console/header';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Box from '@amzn/awsui-components-console/box';
import StatusIndicator from '@amzn/awsui-components-console/status-indicator';
import Icon from '@amzn/awsui-components-console/icon';
import Button from '@amzn/awsui-components-console/button';
import Badge from '@amzn/awsui-components-console/badge';

const insights = [
  {
    type: 'warning' as const,
    text: 'carrier_perf_bco has no new data since Apr 16 — upstream may have stopped sending',
    time: '2h ago',
    badge: 'Data Gap',
  },
  {
    type: 'error' as const,
    text: 'Processing success rate dropped 2% this week — 3 datasets affected',
    time: '4h ago',
    badge: 'Degradation',
  },
  {
    type: 'success' as const,
    text: 'retail_cga volume increased 40% — consider scaling processing',
    time: '6h ago',
    badge: 'Growth',
  },
  {
    type: 'info' as const,
    text: 'ecdd_etd_eu schema drift detected — 2 new fields in upstream source',
    time: '1d ago',
    badge: 'Schema',
  },
];

export const AIInsights: React.FC = () => (
  <Container
    header={
      <Header
        variant="h2"
        description="AI-generated observations across your datasets"
        actions={<Button iconName="refresh">Refresh</Button>}
      >
        <SpaceBetween direction="horizontal" size="xs">
          <Icon name="gen-ai" />
          AI Insights
        </SpaceBetween>
      </Header>
    }
  >
    <SpaceBetween size="m">
      {insights.map((item, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <SpaceBetween direction="horizontal" size="xs">
            <StatusIndicator type={item.type}>{item.text}</StatusIndicator>
            <Badge color={item.type === 'error' ? 'red' : item.type === 'warning' ? 'red' : 'blue'}>
              {item.badge}
            </Badge>
          </SpaceBetween>
          <SpaceBetween direction="horizontal" size="xs">
            <Box color="text-body-secondary" fontSize="body-s">{item.time}</Box>
            <Button variant="inline-link">View details</Button>
          </SpaceBetween>
        </div>
      ))}
    </SpaceBetween>
  </Container>
);

export default AIInsights;
